// import UnprocessableEntityException from "./exceptions/UnprocessableEntityException";
// import FormValidationException from "./exceptions/FormValidationException";
// import AuthenticationException from "./exceptions/AuthenticationException";
import VueErrorHandler from "./VueErrorHandler";
import AppVue from "./AppVue";
// import InternalApplicationException from "./exceptions/InternalApplicationException";

export default (exception) => {
    VueErrorHandler(exception,AppVue)
}